<template>
  <div class="wrap">
    <div class="display-account">
      <div>
        <div class="name">{{ name }}</div>
        <div v-if="affiliation" class="affiliation">{{ affiliation }}</div>
      </div>
      <div class="pic" :class="{ 'no-img': !imgSrc, 'no-name': !name }">
        <span v-if="!imgSrc" class="initials">{{ initials }}</span>
        <img v-if="imgSrc" :src="imgSrc" :alt="`${imgAltText} profile picture`" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: '',
    },
    accountName: {
      type: String,
      default: '',
    },
    affiliation: {
      type: String,
      default: '',
    },
    imgSrc: {
      type: String,
      default: '',
    },
  },
  computed: {
    initials() {
      if (!this.name) {
        return 'NA'
      }
      const nameArray = this.name.split(' ')
      if (nameArray.length === 1) {
        return nameArray[0].charAt(0).toUpperCase()
      }
      return `${nameArray[0].charAt(0).toUpperCase()}${nameArray
        .slice(-1)[0]
        .charAt(0)
        .toUpperCase()}`
    },
    imgAltText() {
      return this.accountName || this.name
    },
  },
}
</script>

<style scoped lang="scss">
.wrap {
  display: inline-block;
  border-radius: 4px;
  margin-left: 4px;

  @media screen and (min-width: 465px) {
    margin-left: 16px;
  }
  @media screen and (min-width: 768px) {
    background: #f6f6f6;
    &:hover {
      background: #f0f0f0;
    }
    padding: 8px 12px;
    margin-left: 16px;
    margin-right: 9px;
  }
}
.display-account {
  font-weight: 500;
  display: flex;
  align-items: center;
  .name {
    color: #0e0d12;
    font-size: 14px;
    line-height: 14px;
    @media screen and (max-width: 768px) {
      display: none;
    }
  }
  .affiliation {
    color: #0e0d12;
    margin-top: 5px;
    font-size: 13px;
    line-height: 13px;
    opacity: 0.6;
    @media screen and (max-width: 768px) {
      display: none;
    }
  }
  .pic {
    border-radius: 50%;
    position: relative;
    width: 32px;
    height: 32px;
    overflow: hidden;
    background: #fff;
    @media screen and (min-width: 768px) {
      margin-left: 14px;
      &.no-name {
        margin-left: 0;
      }
    }
    &.no-img {
      background: #777787;
      color: #fff;
      font-weight: 600;
      font-size: 13px;
    }
    img,
    .initials {
      position: absolute;
      left: 50%;
      top: 50%;
      max-height: 32px;
      max-width: 32px;
      -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
    }
  }
}
</style>
